import {useState, useRef, useEffect} from 'react';
import styles from './Select.module.scss';
import Icon from "../Icon/Icon";
import clsx from "clsx";

const Select = ({ options = [], value, onChange, placeholder = "Select an option" }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsExpanded(false);
            }
        };

        isExpanded &&
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isExpanded]);

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    const handleSelect = (optionValue) => {
        onChange(optionValue);
    };

    const selectedOption = options.find((opt) => opt.value === value);

    return (
        <div className={styles.select} ref={ref}>
            <button
                className={clsx(styles.cta, {
                    [styles.expanded]: isExpanded,
                })}
                type="button"
                aria-label="Select payment terms"
                aria-expanded={isExpanded}
                aria-controls="select-list"
                onClick={handleToggle}
            >
                {selectedOption ? selectedOption.label : placeholder}
                <Icon name={'arrow-down'} size={12} color={'var(--color-teal)'}/>
            </button>
            {isExpanded && (
                <ul className={styles.list} id="select-list">
                    {options.map((option) => (
                        <li key={option.value} className={styles.item}>
                            <button
                                type="button"
                                className={styles.option}
                                onClick={() => handleSelect(option.value)}
                            >
                                {option.label}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Select;
